'use client';

// 活動內容
import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setFullImageModal } from '@/slices/popSlice';
import '../../styles/news.scss';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const EventsActivityContent = ({ content }) => {
    const dispatch = useDispatch();

    // 處理 html
    const createContent = useCallback(() => {
        String.prototype.replaceAll = function (target, payload) {
            const regex = new RegExp(target, 'g');

            return this.valueOf().replace(regex, payload);
        };

        let newContent = content || '';

        if (newContent.includes('<img'))
            newContent = newContent.replaceAll(
                '<img',
                '<img loading="lazy" class="cp" width="100%" height="100%" alt="illustration"'
            );

        return { __html: newContent };
    }, [content]);

    // 點擊圖片放大
    const handleImage = useCallback(() => {
        const figureImages = document.querySelectorAll('figure > img');
        const pImages = document.querySelectorAll('.events-editor > p > img');
        const iFrames = document.querySelectorAll('figure iframe');

        figureImages?.forEach((img) => {
            img?.addEventListener('click', () => {
                dispatch(setFullImageModal(`<img src=${img?.src} alt="pop_image" />`));
            });
        });

        pImages?.forEach((img) => {
            img?.addEventListener('click', () => {
                dispatch(setFullImageModal(`<img src={${img?.src}} alt="pop_image" />`));
            });
        });

        iFrames?.forEach((iframe) => {
            if (!iframe.title) iframe.title = 'myFrame';
        });
    });

    useEffect(() => {
        handleImage();
    }, []);

    const processIframely = async () => {
        const funcArray = [];
        document.querySelectorAll('oembed[url]').forEach((element) => {
            if (!element.hasChildNodes() && window.iframely) {
                funcArray.push(() => {
                    window.iframely.load(element, element.attributes.url.value);
                });
            }
        });
        for (const func of funcArray) {
            await sleep(50);
            func();
        }
    };

    useEffect(() => {
        if (window.iframely) processIframely();
    }, [content]);

    return (
        <div
            className="news-content my-[60px] umd:my-[35px] usm:!my-[30px]"
            dangerouslySetInnerHTML={createContent()}
        />
    );
};

export default EventsActivityContent;
